import React from "react";
import ArticlePreview from "../components/ArticlePreview";

// eslint-disable-next-line react/prop-types
export default function BlogIndex({ data }) {
	const { edges: posts } = data.allMarkdownRemark,
		{ displayBlogPreviewImages } = data.site.siteMetadata;

	return (
		<main className="container container-page">
			<div>
				{posts
					.filter(post => post.node.frontmatter.title.length > 0)
					.map(({ node: post }) => {
						return (
							<ArticlePreview
								displayImages={displayBlogPreviewImages}
								post={post}
								key={post.id}
							/>
						);
					})}
			</div>
		</main>
	);
}

export const pageQuery = graphql`
	query BlogIndex {
		allMarkdownRemark(
			sort: { order: DESC, fields: [frontmatter___date] }
			filter: { fields: { contentType: { eq: "blog" } } }
			limit: 100
		) {
			edges {
				node {
					id
					excerpt(pruneLength: 260)
					frontmatter {
						title
						date(formatString: "DD MMMM, YYYY")
						tags
						path
						cover {
							childImageSharp {
								sizes(maxWidth: 630) {
									...GatsbyImageSharpSizes
								}
							}
						}
					}
				}
			}
		}
		site {
			siteMetadata {
				displayBlogPreviewImages
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/index.js